import React, { useContext, useState } from "react";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  Typography,
  Button,
  IconButton,
  TextField,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { REMARK_STUDENT_TRANSFER_AND_PAID_BUT_NOT_COUNT } from "../../Schema/Enrollment";
import { translateLauguage } from "../../Function/Translate";
import moment from "moment";

export default function RemarkStuTransferAndPaidButNotCount({
  open,
  handleClose,
  editData,
  setRefetch,
}) {

  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  const [remarkStudentTransferPaidNotCount, setRemarkStudentTransferPaidNotCount] = useState("");

  //=================== ====================
  const [remarkStudentTransferOutAndPaidButNotCountInEnrollFee] = useMutation(REMARK_STUDENT_TRANSFER_AND_PAID_BUT_NOT_COUNT, {
    onCompleted: ({ remarkStudentTransferOutAndPaidButNotCountInEnrollFee }) => {
      console.log("remarkStudentTransferOutAndPaidButNotCountInEnrollFee", remarkStudentTransferOutAndPaidButNotCountInEnrollFee)
      setLoading(false);
      if (remarkStudentTransferOutAndPaidButNotCountInEnrollFee?.status === true) {
        setAlert(true, "success", remarkStudentTransferOutAndPaidButNotCountInEnrollFee?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", remarkStudentTransferOutAndPaidButNotCountInEnrollFee?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });


  let userLogin = JSON.parse(window.localStorage.getItem("userLogin"));

  const handleRefundAmount = () => {

    setLoading(true);
    remarkStudentTransferOutAndPaidButNotCountInEnrollFee({
      variables: {
        enrollmentId: editData?._id,
        input: {
          remark: remarkStudentTransferPaidNotCount,
          remarkAt: moment()?.format("YYYY-MM-DD"),
          remarkBy: userLogin?._id,
        }
      }
    })

  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="xs">

      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              Remove From List Paid School Fee
            </Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={1}>

          <Grid item xs={12}>
            <Stack direction="row" spacing={1}>
              <Typography textAlign="left" width="130px">
                Academic Year
              </Typography>
              <Typography textAlign="center" fontWeight="bold">
                : {editData?.academicYearName}
              </Typography>
            </Stack>

            <Stack direction="row" spacing={1}>
              <Typography textAlign="left" width="130px">
                Class:
              </Typography>
              <Typography textAlign="center" fontWeight="bold">
                : {editData?.className}
              </Typography>
            </Stack>

          </Grid>


          <Grid item xs={12} mt={2}>
            <Typography textAlign="left">
              Remark
            </Typography>
            <TextField
              value={remarkStudentTransferPaidNotCount}
              onChange={(e) => setRemarkStudentTransferPaidNotCount(e.target.value)}
              fullWidth
              multiline
              placeholder="remark"
            />
          </Grid>

          <Grid item xs={12}>
            {loading ? (
              <Button className="btn-refund" fullWidth>
                {t("loading")}
              </Button>
            ) : (
              <Button
                className={remarkStudentTransferPaidNotCount === "" ? "" : "btn-refund"}
                fullWidth
                onClick={handleRefundAmount}
                disabled={remarkStudentTransferPaidNotCount === "" ? true : false}
              >
                Update Now
              </Button>
            )}
          </Grid>

        </Grid>
      </DialogContent>
    </Dialog>
  );
}
